import { EncartEdito } from '@components/encart-edito/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const encartEditoMock: Block<EncartEdito> = {
  type: 'encart-edito',
  data: {
    author: {
      firstName: 'Arnaud',
      lastName: 'Allantaz',
      position: "Directeur d'enseigne",
    },
    editorial: {
      title: "L'edito d'Arnaud",
      content:
        "SoCoo'c est présent sur une grande partie du territoire mais nous continuons de rencontrer des candidats à la franchise pour atteindre le nombre de 240 magasins d'ici 2025. La franchise est un modèle ultraperformant basé sur un système vertueux d'échange et de partage avec des dirigeants pleinement investis, capables de challenger l'enseigne et ce, dans un intérêt commun de réussite collective. SoCoo'c rencontre des candidats venus de tous horizons, pas forcément du monde de la cuisine car tous nos franchisés bénéficient d'un accompagnement sur-mesure au quotidien.",
    },
    bannerImage: imageMock,
    svgStickers: [
      {
        svg: '/assets/tmp/store.svg',
      },
      {
        svg: '/assets/tmp/store.svg',
      },
    ],
  },
};
